import qs from 'qs';
import { network } from 'services/network';

export const getPoapViewById = (params: QueryParams) => {
    const queryString = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getPoapViewById${queryString}`;

    return network.get(url).then((response) => response.data);
};

export interface QueryParams {
    viewId: number;
}
